import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Spinner — animated loading glyph.
 *
 * Replaces `fa-solid fa-spinner fa-spin` (the Font Awesome icon the
 * app was using before). Honours WCAG 2.3.3 — the animation
 * freezes under `prefers-reduced-motion: reduce` and the spinner
 * remains visible as a static ring.
 *
 * @example
 *   <Spinner />
 *   <Spinner size="lg" label="Loading users…" />
 *   <p>Submitting <Spinner inline size="xs" /></p>
 */
export function Spinner({ size = 'md', ariaLabel = 'Loading', label, inline = false, className, ...rest }) {
    const classes = [
        'osd-spinner',
        `osd-spinner--${size}`,
        inline ? 'osd-spinner--inline' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    const accessibleName = label !== undefined && label !== null ? String(label) : ariaLabel;
    return (_jsxs("span", { className: classes, role: "status", "aria-live": "polite", "aria-label": accessibleName, ...rest, children: [_jsxs("svg", { className: "osd-spinner__ring", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-hidden": "true", children: [_jsx("circle", { cx: "12", cy: "12", r: "9", fill: "none", stroke: "var(--osd-color-spinner-track)", strokeWidth: "2.5" }), _jsx("circle", { cx: "12", cy: "12", r: "9", fill: "none", stroke: "var(--osd-color-spinner-head)", strokeWidth: "2.5", strokeLinecap: "round", strokeDasharray: "14 56" })] }), label !== undefined && label !== null && _jsx("span", { className: "osd-spinner__label", children: label })] }));
}
//# sourceMappingURL=Spinner.js.map